import React, { useCallback, useEffect, useState } from 'react';
import StyledDropzone from './Forms/StyledDropzone';

interface Props {
  file?: File;
  onDrop: (file?: File) => void;
}

export const CSVDropzone = ({ onDrop, file }: Props): React.JSX.Element => {
  const [_file, setFile] = useState<File>();

  useEffect(() => {
    setFile(file);
  }, [file]);

  useEffect(() => {
    onDrop(_file);
  }, [_file]);

  const drop = useCallback(
    (files: File[]) => {
      const newFile = files.shift();
      setFile(newFile);
    },
    [onDrop],
  );

  return (
    <section style={{ width: '100%' }}>
      <StyledDropzone
        instructions={'Drop the import file here, or click to select the import file'}
        accept="text/csv, text/plain, .csv, application/json, .json"
        onDrop={drop}
        onFileDialogCancel={() => setFile(undefined)}
        multiple={false}
      />
    </section>
  );
};
